import React from "react";
import "../styles/Footer.scss";

class Footer extends React.Component {
  render() {
    return (
      <footer>
        <hr />
        <p className="serif-italic-font">&copy; Estelle Leeds 2020</p>
      </footer>
    );
  }
}

export default Footer;
